import { jwtDecode, jwtGetClaim } from '@/helpers/jwt.js'
import { permissions as pList } from '@/enums/Permissions'

let initialState = {
  roles: false,
  permissions: false
}

export default {
  state: () => initialState,
  mutations: {
    SET_PERMISSIONS(state, jwt) {
      if (jwt) {
        state.roles = jwtGetClaim(jwt, 'role')
        const decodedJwt = jwtDecode(jwt);
        state.permissions = [
          ...(decodedJwt?.selectedOrganization?.permissions || []),
          ...(decodedJwt?.userPermissions || [])
        ];
      }
    },
    RESET_PERMISSIONS(state) {
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    MERGE_PERMISSIONS(state, newPermissions) {
      const current = Array.isArray(state.permissions) ? state.permissions : []
      const merged = new Set([...current, Array.isArray(newPermissions) ? newPermissions : []])
      state.permissions = Array.from(merged)
    }
  },
  actions: {
    setPermissions({ commit }, jwt) {
      commit('SET_PERMISSIONS', jwt)
    },
    resetPermissions({ commit }) {
      commit('RESET_PERMISSIONS')
    },
    mergePermissions({ commit }, newPermissions) {
      commit('MERGE_PERMISSIONS', newPermissions)
    }
  },
  getters: {
    permissionsList: () => {
      return Object.values(pList)
    },
    roles: state => {
      return state.roles
    },
    hasRole: state => role => {
      if (Array.isArray(state.roles)) {
        return state.roles.find(el => el === role) === undefined ? false : true
      } else {
        return state.roles === role
      }
    },
    hasPermission: state => permission => {
      if (Array.isArray(state.permissions)) {
        return state.permissions.find(el => el === permission) === undefined
          ? false
          : true
      } else {
        return state.permissions === permission
      }
    }
  }
}
